// Per-day check-offs: which items in which stacks did the user take today?
// Stored as { dateKey: { stackId: [itemId, ...] } }.

const K = 'mystack:tracking:v1';

function safeParse<T>(s: string | null, fallback: T): T {
  if (!s) return fallback;
  try { return JSON.parse(s) as T; } catch { return fallback; }
}

export function todayKey(): string {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

export function loadDay(dayKey: string): Record<string, string[]> {
  const all = safeParse<Record<string, Record<string, string[]>>>(localStorage.getItem(K), {});
  return all[dayKey] || {};
}

export function toggleItem(stackId: string, itemId: string): boolean {
  const all = safeParse<Record<string, Record<string, string[]>>>(localStorage.getItem(K), {});
  const day = todayKey();
  if (!all[day]) all[day] = {};
  if (!all[day][stackId]) all[day][stackId] = [];
  const arr = all[day][stackId];
  const idx = arr.indexOf(itemId);
  let nowOn: boolean;
  if (idx >= 0) {
    arr.splice(idx, 1);
    nowOn = false;
  } else {
    arr.push(itemId);
    nowOn = true;
  }
  localStorage.setItem(K, JSON.stringify(all));
  return nowOn;
}

export function isItemChecked(stackId: string, itemId: string): boolean {
  return (loadDay(todayKey())[stackId] || []).includes(itemId);
}
